import React from 'react'
import { useTranslation } from 'react-i18next'

import { Title } from '../../../components/presentation/Text'
import FlexGrid from '../../../components/structure/FlexGrid'

const ModalHeader = () => {
  const { t } = useTranslation('bulkEditNonCompliance')
  return (
    <FlexGrid justify="flex-start" gutter={0.3}>
      <Title size="h4" noMargin>
        {t('title')}
      </Title>
    </FlexGrid>
  )
}

export default ModalHeader
